/* global __CONFIG__ */

import Fingerprint2 from 'fingerprintjs2';

/**
 * @param {String} [name]
 * @param {String} [value]
 * @param {Number} [expireDay]
 * @returns void
 */
export const setCookie = (name, value, expireDay = 90) => {
  const d = new Date();
  d.setTime(d.getTime() + expireDay * 864e5);
  const expires = `expires= ${d.toUTCString()}`;
  const domain = `domain=${__CONFIG__.COOKIE_DOMAIN}`;
  document.cookie = `${name}=${value};${domain};${expires};path=/`;
};

/**
 * @param {String} [name]
 * @returns void
 */
export const deleteCookie = (name) => {
  const expires = 'expires= Thu, 01 Jan 1970 00:00:00 UTC';
  const domain = `domain=${__CONFIG__.COOKIE_DOMAIN}`;
  document.cookie = `${name}=;${domain};${expires};path=/`;
};

/**
 * @param {String} name
 * @returns {String} || null
 */
export const readCookie = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      const value = decodeURIComponent(c.substring(nameEQ.length, c.length));

      return value && value !== 'undefined' ? value : null;
    }
  }

  return null;
};

/**
 * @param {Object} [authInfo]
 */
export const saveCookieFromUserData = (authInfo) => {
  const {
    user: {
      first_name: firstName,
      last_name: lastName,
      country_code: countryCode,
      username,
      snapask_uid: userId,
      profile_pic_url: profilePicUrl,
      email,
      role: { name: role },
      region: { name: region },
      phone,
    } = {},
    login_type: loginType,
  } = authInfo;

  setCookie(
    'userData',
    JSON.stringify({
      userId: userId.toString(),
      username: encodeURIComponent(username),
      avatar: profilePicUrl,
      role,
      email,
      countryCode,
      firstName: firstName ? encodeURIComponent(firstName) : '',
      lastName: lastName ? encodeURIComponent(lastName) : '',
      region,
      loginType,
      phone,
    })
  );
};

export const deleteAuthCookie = () => {
  deleteCookie('token');
  deleteCookie('userData');
};

export const generateAndSetDeviceId = () => {
  if (readCookie('deviceID')) {
    return;
  }
  new Fingerprint2().get((hash) => {
    setCookie('deviceID', hash);
  });
};



// WEBPACK FOOTER //
// ./src/services/cookies.js